module.exports = __webpack_public_path__ + "static/img/IMG_20240610_120521.883a71c6.jpg";